import React from 'react'
import PropTypes from 'prop-types'
import { Container } from '@scentregroup/ui'
import { Spotlight, SpotlightCard } from '../'
import style from '../../container.scss'
import { trackClickEvent } from './analytics'

const SpotlightModule = ({ moduleProps, useAlternateDesign }) => (
  <Container type="large" className={style.container}>
    <Spotlight
      heading={moduleProps.title}
      alternateDesign={useAlternateDesign}
      {...moduleProps}
    >
      {(moduleProps.entries || []).map(entry => (
        <SpotlightCard
          {...entry}
          color={moduleProps.color}
          key={entry.id}
          alternateDesign={useAlternateDesign}
          onClick={() =>
            trackClickEvent(
              entry.title,
              moduleProps.heading || moduleProps.title
            )
          }
        />
      ))}
    </Spotlight>
  </Container>
)

SpotlightModule.propTypes = {
  useAlternateDesign: PropTypes.bool,
  moduleProps: PropTypes.object,
}

export default SpotlightModule
